/**
 * Import and define sections pages
 */
// import * as homePage from "./home";
// export const pages = [homePage];
export const pages = [];